<template>
  <b-container fluid>
    <h1>Orders with Product</h1>

    <b-form @submit.prevent="searchOrders()">
      <b-row class="mb-5">
        <b-col>
          <label>Start Date</label>
        </b-col>
        <b-col>
          <b-input v-model="startDate" type="date" class='mb-2 ml-1 mr-2 mb-sm-0' min="2000-01-01" :max="$moment().format('YYYY-MM-DD')" />
        </b-col>
        <b-col>
          <label>End Date</label>
        </b-col>
        <b-col>
          <b-input v-model="endDate" type="date" class='mb-2 ml-1 mr-2 mb-sm-0' min="2000-01-01" :max="$moment().format('YYYY-MM-DD')" />
        </b-col>
        <b-col>
          <label><em>Exact</em> Product Num</label>
        </b-col>
        <b-col>
          <input type="text" v-model="productNum" class='form-control mb-2 ml-1 mr-2 mb-sm-0' onfocus="this.select();" onmouseup="return false;" />
        </b-col>
        <b-col>
          <label>Include Kit Children?</label>
        </b-col>
        <b-col>
          <b-select :options="{false: 'Yes', true: 'No' }" v-model="topLevel" />
        </b-col>
        <b-col>
          <b-button variant="primary" @click="searchOrders()">Search</b-button>
        </b-col>
      </b-row>
    </b-form>

    <section v-if="loading" style="text-align: center;">
      <fingerprint-spinner :animation-duration="1500" :size="300" color="#293a93" class="my-3" />
    </section>
    <section v-else>
      <b-row>
        <b-col cols="3">
          <b-alert variant="warning" show>This report does not include parts made from BOMs!</b-alert>

          <div v-if="orders.length > 0">
          <p><strong>Total on Estimates</strong>: {{orderSummary.map( (o) => o.estimateQuantity ).reduce( (a,v) => a+v, 0)}}</p>
          <p><strong>Total Issued</strong>: {{orderSummary.map( (o) => o.issuedQuantity ).reduce( (a,v) => a+v, 0)}}</p>
          <p><strong>Total Fulfilled</strong>: {{orderSummary.map( (o) => o.fulfilledQuantity ).reduce( (a,v) => a+v, 0)}}</p>
          <p><strong>Total # Orders</strong>: {{orders.length}}</p>
          <p><b-button variant="info" @click="$refs.listModal.show()">Get Plain Order List</b-button></p>
          </div>
        </b-col>
        <b-col cols="9">
          <b-table
            :items="orderSummary"
            :fields="fields"
          >
            <template slot="nums" slot-scope="data">
              <span v-for="num in data.item.nums" :key="num" ><router-link target="_blank" :to="'/sales-order/view/' + num">{{num}}</router-link> &nbsp; </span>
            </template>
            <template slot="orders" slot-scope="data">
              {{data.item.nums.length}}
            </template>
          </b-table>
        </b-col>
      </b-row>
    </section>


    <b-modal ref="listModal" size="lg" title="List of Orders" hide-footer>
      <b-row>
        <b-col>
          <pre>{{ orderList }}</pre>
        </b-col>
        <b-col>
          <b-button
            variant="link"
            v-b-popover.hover="'Click to Copy List'"
            @click="copyToClipboard(orderList)"
            >
            <i class="fas fa-clipboard fa-5x"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </b-container>
</template>

<script>
import axios from 'axios';
import NiceDate from '../../utility/NiceDate';
import fishbowlHelper from '../../../helpers/services/fishbowl';
import { FingerprintSpinner } from 'epic-spinners';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  data() {
    return {
      startDate: '',
      endDate: '',
      productNum: '',
      topLevel: false,
      orders: [],
      loading: false,
      fields: {
        'date': 'Date',
        'estimateQuantity': 'Qty on Estimates',
        'issuedQuantity': 'Qty Issued',
        'fulfilledQuantity': 'Qty Fulfilled',
        'orders': '# Orders',
        'nums': 'Orders'
      }
    }
  },
  components: {
    FingerprintSpinner,
  },
  methods: {
    searchOrders() {
      this.loading = true
      this.orders = []
      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/fishbowl/order/range`,
        data: {
          startDate: this.startDate,
          endDate: this.endDate,
          num: this.productNum,
          top: this.topLevel
        },
      }).then((response) => {
        this.orders = response.data;
        this.loading = false
      });
    },
    copyToClipboard(text) {
      if (window.clipboardData && window.clipboardData.setData) {
        // IE specific code path to prevent textarea being shown while dialog is visible.
        return clipboardData.setData("Text", text);
      } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy");  // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return false;
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
  },
  computed: {
    dates() {
      return [...new Set(this.orders.map( (o) => o.dateIssued))].sort()
    },
    orderSummary() {
      return this.dates.map( (d) => {
        let os = this.orders.filter( (o) => o.dateIssued == d)
        return {
          date: d,
          estimateQuantity: os.filter( (o) => o.statusId == 10 ).map( (o) => o.quantity).reduce( (a,v) => a+v, 0),
          issuedQuantity: os.filter( (o) => o.statusId > 10 && o.statusId < 50 ).map( (o) => o.quantity).reduce( (a,v) => a+v, 0),
          fulfilledQuantity: os.filter( (o) => o.statusId == 50 ).map( (o) => o.quantity).reduce( (a,v) => a+v, 0),
          nums: os.map( (o) => o.num)
        }
      })
    },
    orderList() {
      return this.orders.map( i => i.num).join("\n")
    }
  }
}
</script>

<style scoped>
  pre {
    max-height: 75vh;
    overflow-y: scroll;
  }
  td:first-child {
    min-width: 90px;
  }
  th:nth-child(2), th:nth-child(3), th:nth-child(4), th:nth-child(5), td:nth-child(2), td:nth-child(3), td:nth-child(4), td:nth-child(5) {
    text-align: center !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/sales-order/reports/OrdersWithProduct.vue